import { Component, OnInit, Input } from '@angular/core';
import { ProductListComponent } from '../product-list/product-list.component';
import { CategoryService } from '@app/services/Category/category.service';
import { SubCategoryService } from '@app/services/SubCategory/sub-category.service';
import { Country, State, City } from 'country-state-city';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BusinessAdsService } from '@app/services/BusinessAds/businessAds.service';
import { environment } from '../../../../environments/environment.prod';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {
  searchString: any;
  categories: any;
  subCategories: any;
  countries: any;
  states: any;
  cities: any;

  public form!: FormGroup;
  @Input() productList!: ProductListComponent;
  
  //For toggle hide show
	toggleClass: boolean = false;
  filterTabEvent(){
      this.toggleClass = !this.toggleClass;       
  }
 
  name = new FormControl(null, [Validators.required]);
  category = new FormControl('');
  subCategory = new FormControl({ value: null, disabled: true });
  country = new FormControl('');
  state = new FormControl({ value: null, disabled: true });
  city = new FormControl({ value: null, disabled: true });
  
  constructor(
    private categoryService: CategoryService,
    private subCatService: SubCategoryService,
    private adsService: BusinessAdsService
  ) { 
    this.form = new FormGroup({
      name: this.name,
      category: this.category,
      subCategory: this.subCategory,
      country: this.country,
      state: this.state,
      city: this.city,
    });
  }

  serverUrl:any;
  selectedCountry:any;
  ngOnInit() {
    this.serverUrl = environment.IMG_URL;
    this.categoryList();    
    this.getCountry();
    this.getBusinessAds();
  }
  
  findByTitle(search:any){
    if(search != ''){
      this.searchString= search;
      this.productList.findByTitle(this.searchString);
    }
  }

  filterCriteria = {
    name: null,
    category: null,
    subCategory: null,
    country: null,
    state: null,
    district: null
  };

  reset():void {
    //console.log(this.filterCriteria);
    this.form.reset();
    this.productList.applyFilter(this.filterCriteria);
  }

  applyFilter(): void {
    //console.log(this.filterCriteria);
    this.productList.applyFilter(this.filterCriteria);
  }
  
  getCountry() {
    this.countries = Country.getAllCountries().map(country => ({
      value: country.isoCode,
      displayValue: `${country.name} - ${country.isoCode}`
    })) 
    this.getState();
  }

  getState() {
    this.country.valueChanges.subscribe((country) => {
      this.selectedCountry =country;
      this.state.reset();
      this.state.disable();
      if (country) {
        this.states = State.getStatesOfCountry(country).map(state => ({
          value: state.isoCode,
          displayValue: `${state.name} - ${state.isoCode}`
        }))
        this.state.enable();
      }
    });
    
    this.getCity();
  }

  getCity() {
    this.state.valueChanges.subscribe((state) => {
      this.city.reset();
      this.city.disable();
      if (state) {
        this.cities = City.getCitiesOfState(this.selectedCountry, state).map(city => ({
          value: city.name,
          displayValue: city.name
        }))
        this.city.enable();
      }
    });
  }

  categoryList() {
    this.categoryService.getAll().subscribe({
      next: (response: any) => {
        this.categories = response.data.map((item: any) => {
          return { name: item.CategoryName, id: item.CategoryInfoId };
        });
      }
    });
  }
  
  selectSubCategory(e:any){
    this.category = e.target.value;
    this.getSubCategoryList(this.category);
  }

  getSubCategoryList(category:any) {
      this.subCategory.reset();
      this.subCategory.disable();
      if (category) {
        this.subCatService.getSubcategoryById(category).subscribe({
       next: (response: any) => {
        this.subCategories = response.data.map((item: any) => {
          return { name: item.SubCategoryName, id: item.SubCategoryInfoId }
        });
      }
      })
      this.subCategory.enable();
      }
  };
  
  businessAds:any;
  // Get all business
  getBusinessAds(): void {
    this.adsService.getTop8BusinessAds().subscribe({
      next: (response:any) => {
        this.businessAds = response.data;
        }
      }
    );
  }

  // countryList() {
  //   this.countryService.getAll().subscribe({
  //     next: (response: any) => {
  //       this.countries = response.data.map((item: any) => {
  //         return { displayValue: item.CountryName, value: item.CountryInfoId }
  //       });
  //     }
  //   });
  // }

  // stateList() {
  //   this.distictService.getAll().subscribe({
  //     next: (response: any) => {
  //       this.states = response.data.map((item: any) => {
  //         return { displayValue: item.DistrictName, value: item.DistrictsInfoId }
  //       });
  //     }
  //   });
  // }


  // distList() {
  //   this.distictService.getAll().subscribe({
  //     next: (response: any) => {
  //       this.cities = response.data.map((item: any) => {
  //         return { displayValue: item.DistrictName, name: item.DistrictsInfoId }
  //       });
  //     }
  //   });
  // }

}
